export const ROUTE_KEYS = [
    "HOME",
    "INVOICES",
    "APPOINTMENTS",
    "FORMS",
    "PUBLIC_FORM",
    "APPOINTMENT_BOOKING",
    "CLASS_BOOKING",
    "NOT_AVAILABLE",
    "WAITLIST_REQUEST",
    "REGISTRATION",
    "LOGIN",
    "TELEHEALTH",
    "TELEHEALTH_PLUS",
    "INVOICE_PAY",
    "VIEW_INVOICE",
    "VIEW_STATEMENT",
    "ACCESS_DENIED",
    "FORM_SUBMISSION_SUCCESS",
    "INVALID_PORTAL_URL",
    "BROWSER_NOT_SUPPORTED",
    "LINK_UNAVAILABLE",
    "DOCUMENTS",
    "SUBSCRIPTION_INVOICES",
    "EMAIL_PREFERENCES",
] as const;

export type RouteKey = (typeof ROUTE_KEYS)[number];

export const ROUTES: Record<RouteKey, IRouteConfig> = {
    HOME: { pageTitle: "Home", urlPath: "home" },
    INVOICES: { pageTitle: "Invoices", urlPath: "invoices" },
    APPOINTMENTS: { pageTitle: "Appointments", urlPath: "appointments" },
    FORMS: { pageTitle: "Forms", urlPath: "customform" },
    PUBLIC_FORM: { pageTitle: "Custom Form", urlPath: "customform" },
    APPOINTMENT_BOOKING: { pageTitle: "Book appointment", urlPath: "appointment-booking" },
    CLASS_BOOKING: { pageTitle: "Book class", urlPath: "class-booking" },
    NOT_AVAILABLE: { pageTitle: "Not Available", urlPath: "not-available" },
    WAITLIST_REQUEST: { pageTitle: "Waitlist Request", urlPath: "waitlist-request" },
    REGISTRATION: { pageTitle: "Registration", urlPath: "registration" },
    LOGIN: { pageTitle: "Login", urlPath: "login" },
    TELEHEALTH: { pageTitle: "Telehealth", urlPath: "telehealth" },
    TELEHEALTH_PLUS: { pageTitle: "Telehealth", urlPath: "telehealthplus" },
    INVOICE_PAY: { pageTitle: "Invoice Payment", urlPath: "pay" },
    ACCESS_DENIED: { pageTitle: "Access Denied", urlPath: "access-denied" },
    VIEW_INVOICE: { pageTitle: "Your Invoice", urlPath: "viewInvoice" },
    VIEW_STATEMENT: { pageTitle: "Your Statement", urlPath: "ViewStatement" },
    FORM_SUBMISSION_SUCCESS: { pageTitle: "Form Submitted", urlPath: "form-submitted" },
    INVALID_PORTAL_URL: { pageTitle: "Invalid URL", urlPath: "invalid-portal-url" },
    BROWSER_NOT_SUPPORTED: { pageTitle: "Browser Not Supported", urlPath: "not-supported" },
    LINK_UNAVAILABLE: { pageTitle: "Link Unavailable", urlPath: "link-unavailable" },
    DOCUMENTS: { pageTitle: "Your Documents", urlPath: "documents" },
    SUBSCRIPTION_INVOICES: { pageTitle: "Your Zanda Subscription Invoices", urlPath: "ViewInvoices" },
    EMAIL_PREFERENCES: { pageTitle: "Email preferences", urlPath: "unsubscribe" },
};

interface IRouteConfig {
    pageTitle: string;
    urlPath: string;
}
